// @flow

import React, { Component } from "react";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { connect } from "react-redux";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  LinearWizard,
  Step,
} from "@components";

import * as serviceSelectors from "@modules/service/selectors";
import type { ManagerSmsRestriction } from "@modules/service/reducer/manager-sms-notifications/types";
import type { HierarchyAssignment } from "@modules/service/types";

import Step1Rule from "./step1-rule";
import Step2Assignments from "./step2-assignments";

type OwnProps = $Exact<{
  editing: boolean,
  defaultStep: number,
  type: "SMS" | "Pager",
  rule: ?ManagerSmsRestriction,
  assignments: Array<HierarchyAssignment>,
  onCancel: Function,
  onSubmit: Function,
}>;

type PropsFromState = $Exact<{
  isAssignmentsValid: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...PropsFromState,
}>;

export class ManagerSmsNotificationEditModal extends Component<Props> {
  handleSubmit = () => {
    if (this.props.rule) {
      this.props.onSubmit(this.props.rule, this.props.assignments);
    }
  };

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onCancel}>
          {this.props.editing
            ? this.props.t("MANAGER_SMS_NOTIFICATIONS_MODAL_EDIT_TITLE", {
                type: this.props.type,
                id: (this.props.rule || {}).id,
              })
            : this.props.t("MANAGER_SMS_NOTIFICATIONS_MODAL_ADD_TITLE", { type: this.props.type })}
        </ModalHeader>
        <ModalBody className="d-flex flex-column align-content-center">
          <LinearWizard defaultStep={this.props.defaultStep} data={[]}>
            <Step
              component={Step1Rule}
              title={this.props.t("MANAGER_SMS_NOTIFICATIONS_MODAL_STEP1_TITLE")}
            />
            <Step
              component={Step2Assignments}
              title={this.props.t("MANAGER_SMS_NOTIFICATIONS_MODAL_STEP2_TITLE")}
            />
          </LinearWizard>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon={this.props.editing ? "edit" : "add_box"}
            onClick={this.handleSubmit}
            disabled={!this.props.isAssignmentsValid}
          >
            {this.props.editing ? this.props.t("EDIT") : this.props.t("ADD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state): PropsFromState => {
  return {
    isAssignmentsValid: serviceSelectors.isManagerSmsAssignmentsValid(state),
  };
};

export default compose(localize(), connect(mapStateToProps, null))(ManagerSmsNotificationEditModal);
